var render = function render(){var _vm=this,_c=_vm._self._c;return _c('billing-report-panel',{attrs:{"report-key":"glosses-professional","route":"/reports/billing-glosses-professional","file-name":"glosas-por-profissional.xlsx","columns":_vm.columns,"show-professional":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }